import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import TermBanner from '../TermBanner.js';
import Button from '@helios/Button';
import PageHero from '@helios/PageHero';
import StartAdmissionTasks from './StartAdmissionTasks.js';
import { FormattedBrandLogo } from '../FormattedBrandLogo.js';
import { APPLICATION_HERO } from './applicationHero';
import RegularArrowLeftLongIcon from '@/components/icons/regular/arrow-left-long';
import RegularArrowRightFromBracketIcon from '@/components/icons/regular/arrow-right-from-bracket';
import styles from './ApplicationForm.module.scss';
function ApplicationFormSubmitted(t0) {
  const $ = _c(26);
  const {
    site,
    app,
    employer,
    onLogout,
    onBackToApps,
    showTermBanner: t1
  } = t0;
  const showTermBanner = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== showTermBanner) {
    t2 = showTermBanner && <TermBanner />;
    $[0] = showTermBanner;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = classNames(styles["photo-split"], styles["photo-split--sticky-media"]);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <PageHero.Image priority={true} src={APPLICATION_HERO.image} alt="Continue your application" frame="portrait" />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <PageHero.Media placement="split">{t4}<PageHero.Caption><p>{APPLICATION_HERO.graduateName}</p><p><small>Campus Graduate</small></p></PageHero.Caption></PageHero.Media>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <RegularArrowRightFromBracketIcon />;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== onLogout) {
    t7 = <header className={styles.intro__header}><Button iconLeft={t6} onClick={() => onLogout()} size="md" tone="neutral" variant="outline">Log out</Button></header>;
    $[6] = onLogout;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== employer || $[9] !== site) {
    t8 = <FormattedBrandLogo site={site} employer={employer} align="start" />;
    $[8] = employer;
    $[9] = site;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <h1 className={styles["screen-title"]}>Application submitted.</h1>;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== app.form.firstName) {
    t10 = <div className={styles.intro__lead}>Great work, {app.form.firstName}. We've received your application to Campus.</div>;
    $[12] = app.form.firstName;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <StartAdmissionTasks />;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <RegularArrowLeftLongIcon />;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== onBackToApps) {
    t13 = <Button onClick={onBackToApps} variant="outline" iconLeft={t12}>Back to all applications</Button>;
    $[16] = onBackToApps;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t10 || $[19] !== t13 || $[20] !== t7 || $[21] !== t8) {
    t14 = <PageHero><PageHero.Container width="full"><div className={t3}>{t5}<PageHero.Content placement="split"><div className={styles.intro}>{t7}{t8}{t9}{t10}{t11}{t13}</div></PageHero.Content></div></PageHero.Container></PageHero>;
    $[18] = t10;
    $[19] = t13;
    $[20] = t7;
    $[21] = t8;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t14 || $[24] !== t2) {
    t15 = <>{t2}{t14}</>;
    $[23] = t14;
    $[24] = t2;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  return t15;
}
export default ApplicationFormSubmitted;